const TABTRIPS_API_BASE = 'https://api.tabtrips.com/olivrweb/hotelapi';

const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const raw = c.substring(nameEQ.length, c.length);
      try {
        return decodeURIComponent(raw);
      } catch {
        return raw;
      }
    }
  }
  return null;
};

export const authApi = {
  login: async (email, password) => {
    const response = await fetch(`${TABTRIPS_API_BASE}/adminPanel.php/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const errBody = await response.json().catch(() => ({}));
      const err = new Error(errBody.message || `HTTP error! status: ${response.status}`);
      err.status = response.status;
      err.data = errBody;
      throw err;
    }

    return response.json();
  },

  /**
   * Source of truth for RBAC — refetch on app load / refresh.
   * Tries GET then POST (some hosts only accept one).
   */
  getAdminProfile: async (tokenOverride) => {
    const token = tokenOverride || getCookie('adminToken');
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };

    const tryOnce = async (method) => {
      const response = await fetch(
        `${TABTRIPS_API_BASE}/adminPanel.php?action=getAdminProfile`,
        {
          method,
          headers,
          ...(method === 'POST' ? { body: JSON.stringify({}) } : {}),
        }
      );
      const data = await response.json().catch(() => ({}));
      return { response, data };
    };

    let { response, data } = await tryOnce('GET');

    // Fallback POST if GET not allowed / unknown action on GET
    if (
      response.status === 405 ||
      response.status === 404 ||
      (response.ok && data?.status === false && /action|method|not found/i.test(String(data?.message || '')))
    ) {
      ({ response, data } = await tryOnce('POST'));
    }

    if (response.status === 401) {
      const err = new Error(data.message || 'Unauthorized');
      err.status = 401;
      err.data = data;
      throw err;
    }

    // Soft failures: let AuthContext keep the cached session
    if (!response.ok) {
      const err = new Error(data.message || `Profile failed: ${response.status}`);
      err.status = response.status;
      err.data = data;
      throw err;
    }

    return data;
  },

  logout: async () => ({ success: true }),
};
